import React from 'react';
import Avatar from '../avatar/avatar.js';

const TypingIndicator = ({ avatarSrc = null }) => (React.createElement("div", { className: "mbw-typing-indicator-wrapper" },
    React.createElement("div", { className: "mbw-typing-indicator-avatar-container" },
        React.createElement(Avatar, { imgSrc: avatarSrc, type: "round", size: "small" })),
    React.createElement("div", { className: "mbw-typing-indicator" },
        React.createElement("div", { "data-testid": "typing-indicator", className: "mbw-typing-indicator-loader" },
            React.createElement("div", { className: "mbw-typing-indicator-loader-circle" }),
            React.createElement("div", { className: "mbw-typing-indicator-loader-circle" }),
            React.createElement("div", { className: "mbw-typing-indicator-loader-circle" })))));

export { TypingIndicator as default };
//# sourceMappingURL=typing_indicator.js.map
